module.exports = __webpack_public_path__ + "img/block-rosary.d986a111.jpg";